// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1_sDz","loaderOuter":"PageOverlayLoader_loaderOuter__1MWPL"};